import DataLoader from '../Utlis/DataLoader';

const GetAllPosts = async () => {
  try {
    const response = await DataLoader({
      Path: '/api/v1/posts/getposts',
      Type: 'get'
    });
    return response;
  } catch (error) {
    throw error; 
  }
}

export default GetAllPosts;
